import type { Faq, PainPoint } from '../types/content';
export const painPoints: PainPoint[] = [{
  title: 'Emociones acumuladas',
  text: 'Sentís que llevás demasiado encima y no encontrás cómo soltarlo.'
}, {
  title: 'Tensión corporal',
  text: 'Terminás el día con los hombros tensos, rigidez y cansancio.'
}, {
  title: 'Pensar demasiado',
  text: 'Le das vueltas a lo que pasó, pero seguís sintiéndote sobrepasada.'
}, {
  title: 'Desconexión personal',
  text: 'Entre tantas obligaciones, sentís que ya no tenés tiempo para vos.'
}, {
  title: 'Momentos difíciles',
  text: 'Atravesás cambios o situaciones emocionales que te dejan agotada.'
}];
export const faqs: Faq[] = [{
  question: '¿Necesito saber bailar para usar el kit?',
  answer: 'No. Todos los movimientos son sencillos, ilustrados y están pensados para principiantes. No necesitás aprender coreografías.'
}, {
  question: '¿Qué pasa si tengo muy poco tiempo?',
  answer: 'Tenés prácticas breves y un bono con 12 pausas corporales de solo 3 minutos.'
}, {
  question: '¿Necesito mucho espacio o equipamiento especial?',
  answer: 'No. Incluye prácticas para espacios reducidos y movimientos que podés realizar sentada. No necesitás equipamiento especial.'
}, {
  question: '¿Cómo sé por dónde empezar?',
  answer: 'Podés seguir el programa organizado de 21 días o elegir una secuencia según cómo te sientas. Todo viene explicado paso a paso.'
}, {
  question: '¿El kit reemplaza una terapia o tratamiento médico?',
  answer: 'No. Es un recurso de autocuidado y bienestar mediante el movimiento consciente. No reemplaza la atención médica ni psicológica.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Después de comprar, recibís por email acceso inmediato a todo el contenido en formato PDF.'
}];
export const costs = ['Terminás el día con tensiones que no sabés cómo aflojar.', 'Sentís que acumulás demasiadas emociones y preocupaciones.', 'Seguís pensando en lo que pasó sin encontrar un momento de alivio.', 'Las responsabilidades ocupan el tiempo que querías dedicarte.', 'Querés empezar a moverte, pero nunca sabés qué práctica hacer.'];
export const purchases = [['Mariana B.', 'Buenos Aires'], ['Eugenia C.', 'Córdoba'], ['Lorena G.', 'Rosario'], ['Paula D.', 'Mendoza'], ['Sofía R.', 'La Plata'], ['Natalia V.', 'Neuquén'], ['Fernanda T.', 'Mar del Plata']];
